var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampervanBlueBg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 165,
    height: 114,
    viewBox: "0 0 165 114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "campervan-blue-bg",
    transform: "translate(-44 -1068)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_99",
    "data-name": "Rectangle 99",
    width: 165,
    height: 114,
    rx: 20,
    transform: "translate(44 1068)",
    fill: "#04a8e8"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Campervan",
    transform: "translate(82 1159)",
    fill: "#fff",
    fontSize: 14,
    fontFamily: "OpenSans-Semibold, Open Sans",
    fontWeight: 600,
    letterSpacing: "0.035em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "CAMPERVAN")), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(-1470.027 -1502.246)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_917",
    "data-name": "Path 917",
    d: "M1621.749,2639.723c-.289-8.96-3.133-12.6-9.09-12.148-5.4.408-8.128,4.694-7.359,11.869h-42.91c-.382-8.457-2.583-11.727-7.959-11.9-5.492-.172-8.011,2.873-8.976,11.073-1.669-.265-3.842.767-4.717-1.465-.837-2.138-1.734-4.506.162-6.712,1.283-1.494.606-3.331.524-4.952-.141-2.8.868-4.4,3.641-4.865.467-.08.9-.342,1.367-.437,5.651-1.152,10.343-3.483,12.667-9.3.721-1.8,2.579-2.952,4.8-4.508a25.608,25.608,0,0,1-5.963-.549c-3.162-.918-4.13-3.146-2.284-5.9a12.851,12.851,0,0,1,9.906-5.666c3.139-.3,6.314-.289,9.474-.292q31.226-.036,62.452-.012c5.04,0,5.838.711,5.872,5.808.06,9.194.11,18.391-.069,27.582-.062,3.159,1.373,6.077.891,9.294-.326,2.18-.987,3.169-3.351,3.121C1634.526,2639.639,1628.222,2639.723,1621.749,2639.723Zm-60.232-20.53c3.207-.494,6.219-.969,9.236-1.416a2.009,2.009,0,0,0,1.9-1.832c.313-2.621.972-5.226.6-7.872-8.055-1.38-12.821,1.47-14.44,8.784C1560.889,2616.058,1561.388,2617.354,1561.517,2619.192Zm64.047-11.6c-3.969,0-7.944.028-11.919-.012-1.958-.02-1.75,1.311-1.717,2.553.031,1.192-.316,2.62,1.663,2.611,3.987-.019,7.974-.006,12.053-.006A8.3,8.3,0,0,0,1625.565,2607.592Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_918",
    "data-name": "Path 918",
    d: "M1555.957,2653.336c-2.845.074-5.983-2.752-6.069-5.465-.142-4.48,2.379-7.565,6.309-7.717a6.534,6.534,0,0,1,6.738,6.389C1563.047,2650.168,1559.9,2653.234,1555.957,2653.336Z",
    transform: "translate(-2.349 -10.735)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_919",
    "data-name": "Path 919",
    d: "M1633.837,2653.4c-3.32.087-6.525-3.1-6.643-6.608a6.5,6.5,0,0,1,13-.3C1640.27,2649.925,1637.156,2653.308,1633.837,2653.4Z",
    transform: "translate(-20.315 -10.737)",
    fill: "#fff",
    fillRule: "evenodd"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampervanBlueBg);
export default __webpack_public_path__ + "static/media/campervan-blue-bg.7bdedf1012da8d10873227b2e5ad35d0.svg";
export { ForwardRef as ReactComponent };